import { get, makeRequestDeduped } from '../../../../infra/rest';
import { ConversationTag, ConversationTagsData } from '../typings';

const getConversationTags = async (): Promise<ConversationTag[]> => {
  const data = await get<{ tags: ConversationTag[] }>(`/v1/conversation/tags`, {}, true);
  return data.tags;
};

export const getConversationTagsV2 = async ({
  searchAfter,
  searchTerm,
  selectedTags = [],
  limit = 100,
}: {
  searchTerm?: string;
  searchAfter?: string | null;
  selectedTags?: string[];
  limit?: number;
}): Promise<ConversationTagsData> => {
  const data = await makeRequestDeduped<ConversationTagsData>(
    `/v2/conversation/tags`,
    {
      body: JSON.stringify({
        search: searchTerm,
        selectedTags,
        searchAfter,
        limit,
      }),
      method: 'POST',
    },
    true
  );
  return data;
};

export default getConversationTags;
